import authAr from './ar.json'

const messages = {
  ar: {
    ...authAr,
  },
}

export default messages
